// src/Release.js
import React, { useState, useEffect, useRef } from 'react';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  setDoc,
  updateDoc,
  arrayUnion,
  limit
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { getDatabase, ref, set as rdbSet } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage';


// ADD: small debounce util (no extra libs)
const debounce = (fn, wait = 500) => {
  let t;
  function debounced(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  }
  debounced.cancel = () => clearTimeout(t);
  return debounced;
};


/* ─── static lists ─── */
const genresList = [
  { label: 'Alternative',          value: 'Alternative'         },
  { label: 'Blues',                value: 'blues'               },
  { label: 'Classical',            value: 'classical'           },
  { label: 'Country',              value: 'country'             },
  { label: 'Electronic/Dance',     value: 'electronic_dance'    },
  { label: 'Folk',                 value: 'folk'                },
  { label: 'Rap',                  value: 'hip_hop_rap'         },
  { label: 'Indie',                value: 'indie'               },
  { label: 'Jazz',                 value: 'jazz'                },
  { label: 'Latin',                value: 'latin'               },
  { label: 'Metal',                value: 'metal'               },
  { label: 'Pop',                  value: 'pop'                 },
  { label: 'R&B/Soul',             value: 'rnb_soul'            },
  { label: 'Reggae',               value: 'reggae'              },
  { label: 'Rock',                 value: 'rock'                },
  { label: 'World/International',  value: 'world_international' }
];
const TIERS = ['Bronze', 'Silver', 'Gold', 'Platinum'];
const firestore = getFirestore();
const auth = getAuth();
const database = getDatabase();

/* ────────────────────────────────────────────────────────── */
const Release = () => {
  /* ─ artist profile step ─ */
  const [hasProfile, setHasProfile]   = useState(null);                  // 'yes' | 'no' | null
  const [queryArtist, setQueryArtist] = useState('');                    // search input for existing artist
  const [resArtists, setResArtists]   = useState([]);                    // search results for artist
  const [newArtist, setNewArtist]     = useState({
    username: '',
    ArtistName: '',
    email: '',
    password: '',
    profileImageUrl: null
  });

  const [city, setCity]             = useState('');
const [country, setCountry]       = useState('US');
const [stateValue, setStateValue] = useState('');
const [accountCreated, setAccountCreated] = useState(false);

const statesList = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' }
];

const countryList = [
{ label: 'United States', value: 'US' },
{ label: 'United Kingdom', value: 'UK' },
{ label: 'Canada', value: 'CAN' }, // Changed to 3 letters to avoid conflict with 'CA' (California)
{ label: 'Australia', value: 'AUS' }, // Changed to 3 letters to avoid conflict with 'AU' (no direct overlap, but following pattern)
{ label: 'Germany', value: 'DEU' }, // Changed to 3 letters to avoid conflict with 'DE' (Delaware)
{ label: 'Sweden', value: 'SWE' }, // Changed to 3 letters to avoid conflict with 'SE' (no direct overlap, but following pattern)
{ label: 'France', value: 'FRA' }, // Changed to 3 letters to avoid conflict with 'FR' (no direct overlap, but following pattern)
{ label: 'Brazil', value: 'BRA' }, // Changed to 3 letters to avoid conflict with 'BR' (no direct overlap, but following pattern)
{ label: 'Japan', value: 'JP' }, // No conflict, keeping as is
{ label: 'Netherlands', value: 'NLD' }, // Changed to 3 letters to avoid conflict with 'NL' (no direct overlap, but following pattern)
{ label: 'India', value: 'IND' }, // Added for more coverage
{ label: 'China', value: 'CHN' }, // Added for more coverage
{ label: 'Mexico', value: 'MEX' }, // Added for more coverage
{ label: 'Italy', value: 'ITA' }, // Added for more coverage
{ label: 'Spain', value: 'ESP' }, // Added for more coverage
{ label: 'South Korea', value: 'KOR' }, // Added for more coverage
{ label: 'Russia', value: 'RUS' }, // Added for more coverage
{ label: 'South Africa', value: 'ZAF' }, // Added for more coverage
{ label: 'New Zealand', value: 'NZL' }, // Added for more coverage
{ label: 'Norway', value: 'NOR' }, // Added for more coverage
{ label: 'Denmark', value: 'DNK' }, // Added for more coverage
{ label: 'Finland', value: 'FIN' }, // Added for more coverage
{ label: 'Switzerland', value: 'CHE' }, // Added for more coverage
{ label: 'Belgium', value: 'BEL' }, // Added for more coverage
{ label: 'Austria', value: 'AUT' }, // Added for more coverage
{ label: 'Ireland', value: 'IRL' }, // Added for more coverage
{ label: 'Argentina', value: 'ARG' }, // Added for more coverage
{ label: 'Chile', value: 'CHL' }, // Added for more coverage
{ label: 'Colombia', value: 'COL' }, // Added for more coverage
{ label: 'Turkey', value: 'TUR' }, // Added for more coverage
{ label: 'Poland', value: 'POL' }, // Added for more coverage
{ label: 'Portugal', value: 'PRT' }, // Added for more coverage
{ label: 'Greece', value: 'GRC' }, // Added for more coverage
{ label: 'Czech Republic', value: 'CZE' }, // Added for more coverage
{ label: 'Hungary', value: 'HUN' }, // Added for more coverage
{ label: 'Israel', value: 'ISR' }, // Added for more coverage
{ label: 'Singapore', value: 'SGP' }, // Added for more coverage
{ label: 'Malaysia', value: 'MYS' }, // Added for more coverage
{ label: 'Indonesia', value: 'IDN' }, // Added for more coverage
{ label: 'Philippines', value: 'PHL' }, // Added for more coverage
{ label: 'Thailand', value: 'THA' }, // Added for more coverage
{ label: 'Vietnam', value: 'VNM' }, // Added for more coverage
{ label: 'Saudi Arabia', value: 'SAU' }, // Added for more coverage
{ label: 'United Arab Emirates', value: 'ARE' }, // Added for more coverage
{ label: 'Egypt', value: 'EGY' }, // Added for more coverage
{ label: 'Nigeria', value: 'NGA' } // Added for more coverage
];

  const [selectedArtist, setSelectedArtist] = useState(null);

  // ADD: toggle between building a DAT via form vs searching existing release
const [mode, setMode] = useState('form'); // 'form' | 'search'

// ADD: search mode state
const [searchText, setSearchText] = useState('');
const [items, setItems] = useState([]);      // combined user + asset results
const [isLoading, setIsLoading] = useState(false);

// ADD: cached posts from summary to search (musicSummaries/summary_1.posts)
const [summaryPosts, setSummaryPosts] = useState([]);

// ADD: tier selector used in both modes
const [searchTier, setSearchTier] = useState(TIERS[0]);

  

    const navigate = useNavigate();

  /* ─ DAT details ─ */
  const [artwork, setArtwork]   = useState(null);
  const [songFile, setSongFile] = useState(null);
  const [songName, setSongName] = useState('');
  const [tier, setTier]         = useState(TIERS[0]);
  const [genre, setGenre]       = useState(genresList[0].value);

  /* ─ tagging states ─ */
  const [producers,   setProducers]   = useState([]);  // [{tag,id}]
  const [features,    setFeatures]    = useState([]);
  const [songwriters, setSongwriters] = useState([]);
  const [recordLabels,setRecordLabels]= useState([]);

  const [queryProducers,   setQueryProducers]   = useState('');
  const [queryFeatures,    setQueryFeatures]    = useState('');
  const [querySongwriters, setQuerySongwriters] = useState('');
  const [queryLabels,      setQueryLabels]      = useState('');

  const [resProducers,   setResProducers]   = useState([]);
  const [resFeatures,    setResFeatures]    = useState([]);
  const [resSongwriters, setResSongwriters] = useState([]);
  const [resLabels,      setResLabels]      = useState([]);

  const timerRef = useRef(null);

  /* ───────────────── helper ───────────────── */
  const searchUsers = async (input, setter) => {
    const val = input.slice(1).toLowerCase();
    const usersRef = collection(firestore, 'users');
    const q = query(
      usersRef,
      where('username_lower', '>=', val),
      where('username_lower', '<=', val + '\uf8ff'),
      limit(3)
    );
    try {
      const snap = await getDocs(q);
      const users = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setter(users);
    } catch (err) {
      console.error('User search error:', err);
      setter([]);
    }
  };

  // ADD: merge + prioritize helpers used by search
const mergeDedup = (arr) => {
  const map = {};
  arr.forEach(it => {
    const key = `${String(it.id)}_${it.type}`;
    if (!map[key]) map[key] = it;
  });
  return Object.values(map);
};

// ADD: main search — users (by username_lower/ArtistNameLower) + posts (SongName/ArtistName/albumName)
const fetchItems = async () => {
  const q = (searchText || '').trim();
  if (!q) {
    setItems([]);
    setIsLoading(false);
    return;
  }
  setIsLoading(true);
  const searchTextLower = q.toLowerCase();
  const usernameSearchText = searchTextLower.replace(/\s+/g, '');

  try {
    // Users
    const userQuery = query(
      collection(firestore, 'users'),
      where('username_lower', '>=', searchTextLower),
      where('username_lower', '<=', searchTextLower + '\uf8ff'),
      limit(7)
    );

    const userArtistNameQuery = query(
      collection(firestore, 'users'),
      where('ArtistNameLower', '>=', searchTextLower),
      where('ArtistNameLower', '<=', searchTextLower + '\uf8ff'),
      limit(7)
    );

    const exactUsernameQuery = query(
      collection(firestore, 'users'),
      where('username_lower', '==', usernameSearchText),
      limit(7)
    );

    const results = await Promise.all([
      getDocs(userQuery),
      getDocs(userArtistNameQuery),
      getDocs(exactUsernameQuery)
    ]);

    let users = results.flatMap(snap =>
      snap.docs.map(d => ({ id: d.id, ...d.data(), type: 'user' }))
    );

    // Assets from musicSummaries/summary_1.posts
    // We accept both singles and albums; a map may have SongName or albumName
    const assetsMatches = (summaryPosts || [])
      .filter(p => {
        const song = (p.SongName || p.name || '').toLowerCase();
        const album = (p.albumName || '').toLowerCase();
        const artist = (p.ArtistName || p.artistName || '').toLowerCase();
        return song.includes(searchTextLower)
            || album.includes(searchTextLower)
            || artist.includes(searchTextLower);
      })
      .map(p => ({
        ...p,
        id: p.contentId || p.id || p.SongURL || p.albumId || Math.random().toString(36).slice(2),
        type: 'asset'
      }));

    // Dedup
    const unique = mergeDedup([...users, ...assetsMatches]);

    // Split
    const usersOnly = unique.filter(it => it.type === 'user');
    const assetsOnly = unique.filter(it => it.type === 'asset');

    // Prioritize exact-username user, then that user’s assets
    const prioritized = [];
    const others = [];
    let matchedUser = null;
    usersOnly.forEach(u => {
      if (!matchedUser && u.username_lower === usernameSearchText) {
        matchedUser = u;
        prioritized.push(u);
      } else {
        others.push(u);
      }
    });

    const userAssetMatches = matchedUser
      ? assetsOnly.filter(a => (a.userId || a.artistId) === matchedUser.id)
      : [];

    const otherAssetMatches = matchedUser
      ? assetsOnly.filter(a => (a.userId || a.artistId) !== matchedUser.id)
      : assetsOnly;

    // Fan accounts to end
    const fanAccounts = others.filter(u => u.accountType === 'Fan');
    const nonFan = others.filter(u => u.accountType !== 'Fan');

    const finalItems = matchedUser
      ? [...prioritized, ...userAssetMatches, ...otherAssetMatches, ...nonFan, ...fanAccounts]
      : [...prioritized, ...nonFan, ...otherAssetMatches, ...fanAccounts];

    setItems(finalItems);
  } catch (err) {
    console.error('Search error:', err);
  } finally {
    setIsLoading(false);
  }
};

// ADD: debounced trigger on searchText
useEffect(() => {
  if (mode !== 'search') return;
  const debounced = debounce(() => fetchItems(), 500);
  debounced();
  return () => debounced.cancel();
}, [searchText, mode, summaryPosts]);



  // ADD: fetch summary posts (only when switching into search mode)
useEffect(() => {
  let active = true;
  const run = async () => {
    if (mode !== 'search') return;
    try {
      const snap = await getDoc(doc(firestore, 'musicSummaries', 'summary_1'));
      const data = snap.exists() ? (snap.data() || {}) : {};
      const posts = Array.isArray(data.posts) ? data.posts : [];
      if (active) setSummaryPosts(posts);
    } catch (e) {
      console.error('Failed to load summary_1:', e);
      if (active) setSummaryPosts([]);
    }
  };
  run();
  return () => { active = false; };
}, [mode]);


  /* ───────────── debounced search for artist ───────────── */
  useEffect(() => {
    clearTimeout(timerRef.current);
    if (queryArtist.startsWith('@') && queryArtist.length > 1) {
      timerRef.current = setTimeout(() => searchUsers(queryArtist, setResArtists), 300);
    } else {
      setResArtists([]);
    }
    return () => clearTimeout(timerRef.current);
  }, [queryArtist]);

  /* ───────────── debounced search effects ───────────── */
  useEffect(() => {
    clearTimeout(timerRef.current);
    if (queryProducers.startsWith('@') && queryProducers.length > 1) {
      timerRef.current = setTimeout(() => searchUsers(queryProducers, setResProducers), 300);
    } else {
      setResProducers([]);
    }
    return () => clearTimeout(timerRef.current);
  }, [queryProducers]);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (queryFeatures.startsWith('@') && queryFeatures.length > 1) {
      timerRef.current = setTimeout(() => searchUsers(queryFeatures, setResFeatures), 300);
    } else {
      setResFeatures([]);
    }
    return () => clearTimeout(timerRef.current);
  }, [queryFeatures]);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (querySongwriters.startsWith('@') && querySongwriters.length > 1) {
      timerRef.current = setTimeout(() => searchUsers(querySongwriters, setResSongwriters), 300);
    } else {
      setResSongwriters([]);
    }
    return () => clearTimeout(timerRef.current);
  }, [querySongwriters]);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (queryLabels.startsWith('@') && queryLabels.length > 1) {
      timerRef.current = setTimeout(() => searchUsers(queryLabels, setResLabels), 300);
    } else {
      setResLabels([]);
    }
    return () => clearTimeout(timerRef.current);
  }, [queryLabels]);

  /* ───────────── add / remove helpers ───────────── */
  const addTag = (list, setList, query, setQuery, max = 10) => {
    const input = query.trim();
    if (!input || list.length >= max) return;

    // avoid duplicates
    if (list.some(t => t.tag === input)) {
      setQuery('');
      return;
    }
    setList([...list, { tag: input, id: Date.now().toString() }]);
    setQuery('');
  };

  const removeTag = (index, setList) =>
    setList(prev => prev.filter((_, i) => i !== index));

  /* ───────────── choose user helper ───────────── */
  const chooseUser = (user, list, setList, setQuery, setRes, max = 10) => {
    setRes([]);
    if (setList === setRecordLabels && list.length >= 6) return;
    if (setList !== setRecordLabels && list.length >= max) return;
    const formatted = { tag: `@${user.username} - ${user.name}`, id: user.id };
    setList(prev => (prev.some(t => t.id === formatted.id) ? prev : [...prev, formatted]));
    setQuery('');

    /* when picking the main artist */
    if (setRes === setResArtists) {
      setSelectedArtist(user);
      setQueryArtist(`@${user.username} - ${user.name}`);
    }
  };


  // ADD: navigate when selecting a found asset to the same review screen
const handleSelectAssetForDAT = (assetMap) => {
  // Ensure we have an identifier to pass into review
  const contentId = String(assetMap?.contentId || assetMap?.id || '').trim();
  if (!contentId) {
    alert('This item is missing a contentId.');
    return;
  }

  navigate('/view-dat-submission', {
    state: {
      asset: {
        mode: 'fromSummary',
        contentId,
        tier: searchTier,       // user-chosen tier in search mode
        sourceMap: assetMap     // entire map for preview if the review screen wants it
      }
    }
  });
};




  const handleReview = () => {
    if (hasProfile === 'yes' && !selectedArtist) {
      alert('Please select an existing artist profile.');
      return;
    }
    if (hasProfile === 'no' && !newArtist.email) {
      alert('Please fill in the new artist information.');
      return;
    }

    const payload = {
      hasProfile,                    // 'yes' | 'no'
      selectedArtist,                // object or null
      newArtist: hasProfile === 'no' ? newArtist : null,
      artwork,
      songFile,
      songName,
      tier,
      genre,
      credits: {
        producers:    producers.map(p => ({ id: p.id, tag: p.tag })),
        features:     features.map(f => ({ id: f.id, tag: f.tag })),
        songwriters:  songwriters.map(s => ({ id: s.id, tag: s.tag })),
        recordLabels: recordLabels.map(r => ({ id: r.id, tag: r.tag }))
      }
    };

    navigate('/view-dat-submission', { state: { asset: payload } });
  };

  const handleAgreeAndCreateAccount = async () => {
    // pull fields from your state
    const { email, password, username, ArtistName } = newArtist;
  
    // basic validation
    if (!email || !password || !username || !ArtistName || !city) {
      alert('Please fill in all mandatory fields.');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      alert('Invalid email format.');
      return;
    }
  
    try {
      // 1) create auth user
      const auth = getAuth();
      const { user } = await createUserWithEmailAndPassword(auth, email, password);
  
      // 2) set displayName
      await updateProfile(user, { displayName: username });

      const storage = getStorage();
  let uploadedProfileURL = '';
  if (newArtist.profileImageUrl) {
const file = newArtist.profileImageUrl;
const picRef = storageRef(storage, `profile_pictures/${user.uid}`);
const blob = await file.arrayBuffer().then(buf => new Blob([buf]));  // ✅ convert to blob
const uploadTask = uploadBytesResumable(picRef, blob);

await new Promise((resolve, reject) => {
  uploadTask.on('state_changed', null, reject, resolve);
});
uploadedProfileURL = await getDownloadURL(uploadTask.snapshot.ref);  // ✅ safer than picRef

  }
  
      // 3) reserve username in Firestore
      const usernameKey = username.toLowerCase();
      const usernameRef = doc(firestore, 'usernames', usernameKey);
      if ((await getDoc(usernameRef)).exists()) {
        alert('Username already taken');
        return;
      }
      await setDoc(usernameRef, { uid: user.uid });
  
      // 4) build your user doc
      const mandatoryFollowingIds = [
        'h0fEIStkM4XHTDErZM5i8XIo9rA3',
        'OHaY20b54nTGd5BBgbJOL2BHEbX2',
        'rdX289s3YBP31Hw5qn2eXVywtBq1',
        'Mkf4631LCEOYmHXWRzGirPdxBrt1'
      ];
      const userState = country === 'US' ? stateValue : country;
  
      const userData = {
        id: user.uid,
        userId: user.uid,
        email,
        name: ArtistName,
        ArtistName,
        ArtistNameLower: ArtistName.toLowerCase(),
        username,
        username_lower: usernameKey,
        city,
        country,
        state: userState,
        accountType: 'Artist',
        profileImageUrl: uploadedProfileURL,
        lastOperationTime: new Date(),
        purchaseHistory: [],
        salesHistory: [],
        uploadedItems: [],
        purchasedItems: [],
        streamedSongs: [],
        streamedVideos: [],
        following: [...mandatoryFollowingIds],
        purchasedMedia: [],
        ScreenSKN: [],
        ScreenSKNpurchased: [],
        albums: [],
        singles: [],
        videos: [],
        videoalbums: []
      };
  
      // 5) write user doc to Firestore
      await setDoc(doc(firestore, 'users', user.uid), userData);
  
      // 6) initialize RTDB credits + stats
      await rdbSet(ref(database, `users/${user.uid}/credits`), 0);
      await rdbSet(ref(database, `users/${user.uid}/stats`), {
        totalSpns: 0,
        sales: { singles: 0, albums: 0, videos: 0 }
      });
  
      // 7) add this user to mandatory followers
      await Promise.all(
        mandatoryFollowingIds.map(id =>
          updateDoc(doc(firestore, 'users', id), {
            followers: arrayUnion(user.uid)
          })
        )
      );
  
      console.log('User profile created:', user.uid);
      setAccountCreated(true);
  
    } catch (error) {
      console.error('Signup Error:', error);
      alert(error.message);
    }
  };

  /* ───────────── reusable button ───────────── */
  const Button = ({ title, onClick, style = {} }) => (
    <button onClick={onClick} style={{ ...styles.button, ...style }}>
      {title}
    </button>
  );

  /* ───────────── JSX ───────────── */
  return (
    <div className="release-page">



      {/* ADD: Mode switch */}
<div style={{ display: 'flex', gap: 12, justifyContent: 'center', margin: '12px 0 20px' }}>
  <button
    onClick={() => setMode('form')}
    style={{
      ...styles.button,
      opacity: mode === 'form' ? 1 : 0.6
    }}
  >
    Build via Form
  </button>
  <button
    onClick={() => setMode('search')}
    style={{
      ...styles.button,
      opacity: mode === 'search' ? 1 : 0.6
    }}
  >
    Search Existing Release
  </button>
</div>


{/* ADD: Search Mode */}
{mode === 'search' && (
  <section className="section">

    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
      <input
        style={styles.input}
        placeholder="Search by @username, artist name, song or album"
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
        maxLength={80}
      />
      <select
        value={searchTier}
        onChange={e => setSearchTier(e.target.value)}
        style={styles.select}
        title="Choose DAT tier for the selected release"
      >
        {TIERS.map(t => <option key={t} value={t}>{t}</option>)}
      </select>
    </div>

    {isLoading && <p>Searching…</p>}

    {!isLoading && items.length === 0 && searchText.trim().length > 0 && (
      <p>No results.</p>
    )}

    <div style={{ display: 'grid', gap: 8 }}>
      {items.map(item => {
        if (item.type === 'user') {
          return (
            <div
              key={`u_${item.id}`}
              style={{ ...styles.tagItem, cursor: 'pointer' }}
              onClick={() => setSearchText(item.username ? item.username : item.ArtistName || '')}
              title="Click to search this user’s releases"
            >
              @{item.username} — {item.name || item.ArtistName || 'Artist'}
            </div>
          );
        }
        // asset (summary map)
        const title = item.SongName || item.albumName || item.name || 'Untitled';
        const artist = item.ArtistName || item.artistName || '';
        return (
          <div
            key={`a_${item.id}`}
            style={{ ...styles.tagItem, cursor: 'pointer' }}
            onClick={() => handleSelectAssetForDAT(item)}
            title="Select to review DAT submission"
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 700 }}>{title}</span>
              <span style={{ opacity: 0.8 }}>{artist}</span>
            </div>
          </div>
        );
      })}
    </div>
  </section>
)}


{mode === 'form' && (
  <>

      {/* ─── Artist profile ─── */}
      <section className="section">
        <h2>Artist Profile</h2>

        <div className="radio-row">
          <label>
            <input
              type="radio"
              value="yes"
              checked={hasProfile === 'yes'}
              onChange={() => setHasProfile('yes')}
            />{' '}
            Artist has an existing profile
          </label>
          <label>
            <input
              type="radio"
              value="no"
              checked={hasProfile === 'no'}
              onChange={() => setHasProfile('no')}
            />{' '}
            Artist needs a new profile
          </label>
        </div>

        {hasProfile === 'yes' && (
          <>
            {resArtists.map(user => (
              <div
                key={user.id}
                onClick={() => {
                  // Use chooseUser helper to set selectedArtist, clear results, and set the input text
                  chooseUser(
                    user,
                    [],              // we’re not adding to a “list” in this case
                    () => {},        // no state list to append to
                    setQueryArtist,  // this will clear the query
                    setResArtists,   // this clears the results array
                  );
                  // Manually set selectedArtist so handleReview sees it
                  setSelectedArtist(user);
                  setQueryArtist(`@${user.username} - ${user.name}`);
                  setResArtists([]);
                }}
                style={{ cursor: 'pointer', marginBottom: 5 }}
              >
                @{user.username} ({user.name})
              </div>
            ))}

            <div style={{ display: 'flex', gap: 8 }}>
              <input
                style={styles.input}
                placeholder="Enter @username"
                value={queryArtist}
                onChange={e => setQueryArtist(e.target.value)}
                maxLength={50}
              />
            </div>
          </>
        )}

{hasProfile === 'no' && !accountCreated && (
          <>
            <input
              type="text"
              placeholder="Username"
              value={newArtist.username}
              onChange={e => setNewArtist({ ...newArtist, username: e.target.value })}
              style={styles.input}
            />
            <input
              type="text"
              placeholder="Artist Name"
              value={newArtist.ArtistName}
              onChange={e => setNewArtist({ ...newArtist, ArtistName: e.target.value })}
              style={styles.input}
            />
            <input
              type="email"
              placeholder="Email"
              value={newArtist.email}
              onChange={e => setNewArtist({ ...newArtist, email: e.target.value })}
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Password"
              value={newArtist.password}
              onChange={e => setNewArtist({ ...newArtist, password: e.target.value })}
              style={styles.input}
            />
                <p style={{ marginBottom: '8px', fontWeight: 600 }}>Select profile image</p>
                <input
      type="file"
      accept="image/*"
      onChange={e => setNewArtist({ ...newArtist, profileImageUrl: e.target.files[0] })}
      style={styles.input}
    />
    {newArtist.profileImageUrl && (
      <span className="file-name">{newArtist.profileImageUrl.name}</span>
    )}
    <input
  type="text"
  placeholder="Enter City"
  value={city}
  onChange={e => setCity(e.target.value)}
  style={styles.input}
/>

<select
  value={country}
  onChange={e => { setCountry(e.target.value); setStateValue(''); }}
  style={styles.select}
>
  {countryList.map(c => (
    <option key={c.value} value={c.value}>
      {c.label}
    </option>
  ))}
</select>

{country === 'US' && (
  <select
    value={stateValue}
    onChange={e => setStateValue(e.target.value)}
    style={styles.select}
  >
    {statesList.map(s => (
      <option key={s.value} value={s.value}>
        {s.label}
      </option>
    ))}
  </select>
)}

<button
  onClick={handleAgreeAndCreateAccount}
  style={{ ...styles.button, marginTop: 16 }}
>
  Create Account
</button>

          </>
        )}
        {hasProfile === 'no' && accountCreated && (
  <div style={{ textAlign: 'center', marginTop: 16 }}>
    <p style={{ fontSize: '1.25rem', fontWeight: 600 }}>
      @{newArtist.username}
    </p>
    <p>Account successfully created ✅</p>
  </div>
)}

      </section>

      {/* ─── DAT details ─── */}
      <section className="section">
        <h2>DAT Details</h2>

        <input
          type="text"
          placeholder="DAT name"
          value={songName}
          onChange={e => setSongName(e.target.value)}
          style={styles.input}
        />

        <div className="file-row">
          <label className="file-label">
            Upload Artwork
            <input
              type="file"
              accept="image/*"
              onChange={e => setArtwork(e.target.files[0])}
              style={styles.fileInput}
            />
          </label>
          {artwork && <span className="file-name">{artwork.name}</span>}
        </div>

        <div className="file-row">
          <label className="file-label">
            Upload DAT Audio
            <input
              type="file"
              accept="audio/*"
              onChange={e => setSongFile(e.target.files[0])}
              style={styles.fileInput}
            />
          </label>
          {songFile && <span className="file-name">{songFile.name}</span>}
        </div>

        <h2>Tier</h2>
<div className="select-row">
  <select
    value={tier}
    onChange={e => setTier(e.target.value)}
    style={styles.select}
  >
    {TIERS.map(t => (
      <option key={t} value={t}>{t}</option>
    ))}
  </select>
</div>

<h2>Genre</h2>
<div className="select-row">
  <select
    value={genre}
    onChange={e => setGenre(e.target.value)}
    style={styles.select}
  >
    {genresList.map(g => (
      <option key={g.value} value={g.value}>{g.label}</option>
    ))}
  </select>
</div>

      </section>

      {/* ─── Features ─── */}
      <section className="section">
        <h2>Features</h2>

        {resFeatures.map(user => (
          <div
            key={user.id}
            onClick={() =>
              chooseUser(
                user,
                features,
                setFeatures,
                setQueryFeatures,
                setResFeatures
              )
            }
            style={{ cursor: 'pointer', marginBottom: 5 }}
          >
            @{user.username} ({user.name})
          </div>
        ))}

        {features.map((f, i) => (
          <div key={f.id} style={styles.tagItem}>
            <span>{f.tag}</span>
            <button
              onClick={() => removeTag(i, setFeatures)}
              style={styles.removeBtn}
            >
              X
            </button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={styles.input}
            placeholder="Feature name or @username"
            value={queryFeatures}
            onChange={e => setQueryFeatures(e.target.value)}
            maxLength={50}
          />
          <Button
            title="Add"
            onClick={() =>
              addTag(features, setFeatures, queryFeatures, setQueryFeatures)
            }
          />
        </div>
      </section>

      {/* ─── Producers ─── */}
      <section className="section">
        <h2>Producers</h2>

        {resProducers.map(user => (
          <div
            key={user.id}
            onClick={() =>
              chooseUser(
                user,
                producers,
                setProducers,
                setQueryProducers,
                setResProducers
              )
            }
            style={{ cursor: 'pointer', marginBottom: 5 }}
          >
            @{user.username} ({user.name})
          </div>
        ))}

        {producers.map((p, i) => (
          <div key={p.id} style={styles.tagItem}>
            <span>{p.tag}</span>
            <button
              onClick={() => removeTag(i, setProducers)}
              style={styles.removeBtn}
            >
              X
            </button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={styles.input}
            placeholder="Producer name or @username"
            value={queryProducers}
            onChange={e => setQueryProducers(e.target.value)}
            maxLength={50}
          />
          <Button
            title="Add"
            onClick={() =>
              addTag(producers, setProducers, queryProducers, setQueryProducers)
            }
          />
        </div>
      </section>

      {/* ─── Songwriters ─── */}
      <section className="section">
        <h2>Songwriters</h2>

        {resSongwriters.map(user => (
          <div
            key={user.id}
            onClick={() =>
              chooseUser(
                user,
                songwriters,
                setSongwriters,
                setQuerySongwriters,
                setResSongwriters
              )
            }
            style={{ cursor: 'pointer', marginBottom: 5 }}
          >
            @{user.username} ({user.name})
          </div>
        ))}

        {songwriters.map((s, i) => (
          <div key={s.id} style={styles.tagItem}>
            <span>{s.tag}</span>
            <button
              onClick={() => removeTag(i, setSongwriters)}
              style={styles.removeBtn}
            >
              X
            </button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={styles.input}
            placeholder="Songwriter name or @username"
            value={querySongwriters}
            onChange={e => setQuerySongwriters(e.target.value)}
            maxLength={50}
          />
          <Button
            title="Add"
            onClick={() =>
              addTag(
                songwriters,
                setSongwriters,
                querySongwriters,
                setQuerySongwriters
              )
            }
          />
        </div>
      </section>

      {/* ─── Record Labels ─── */}
      <section className="section">
        <h2>Record Labels</h2>

        {resLabels.map(user => (
          <div
            key={user.id}
            onClick={() =>
              chooseUser(
                user,
                recordLabels,
                setRecordLabels,
                setQueryLabels,
                setResLabels,
                6
              )
            }
            style={{ cursor: 'pointer', marginBottom: 5 }}
          >
            @{user.username} ({user.name})
          </div>
        ))}

        {recordLabels.map((r, i) => (
          <div key={r.id} style={styles.tagItem}>
            <span>{r.tag}</span>
            <button
              onClick={() => removeTag(i, setRecordLabels)}
              style={styles.removeBtn}
            >
              X
            </button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={styles.input}
            placeholder="Label name or @username"
            value={queryLabels}
            onChange={e => setQueryLabels(e.target.value)}
            maxLength={50}
          />
          <Button
            title="Add"
            onClick={() =>
              addTag(
                recordLabels,
                setRecordLabels,
                queryLabels,
                setQueryLabels,
                6
              )
            }
          />
        </div>
      </section>

      <Button title="Review" onClick={handleReview} style={{ marginBottom: 30 }} />

        </>
)}

      {/* ─ quick inline styles for page ─ */}
<style>{`
  :root{
    --brand-top:#fe24ad;
    --brand-bot:#a410e8;
    --brand-grad:linear-gradient(135deg,var(--brand-top),var(--brand-bot));
    --brand-top-20:rgba(254,36,173,.2);
    --brand-bot-40:rgba(164,16,232,.4);
  }

  *{margin:0;padding:0;box-sizing:border-box}
  body,html{
    font-family:sans-serif;
    background:#000;
    color:#fff;
  }

  .release-page{
    max-width:600px;
    margin:0 auto;
    padding:1.5rem;
    animation:fadeIn .6s ease-in-out;
    background:
      radial-gradient(600px 400px at 15% 15%, var(--brand-top-20), transparent 60%),
      radial-gradient(500px 350px at 85% 85%, var(--brand-bot-40), transparent 60%);
    border-radius:12px;
  }

  .page-title{
    text-align:center;
    font-size:2rem;
    margin-bottom:1rem;
    background:var(--brand-grad);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }

  .section{margin:1.5rem 0;}
  .section>h2{
    font-size:1.25rem;
    margin-bottom:.75rem;
    background:var(--brand-grad);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }

  .radio-row{display:flex;gap:2rem;flex-wrap:wrap;margin-bottom:1rem;}
  .file-row{display:flex;align-items:center;margin-bottom:1rem;}
  .file-label{
    cursor:pointer;
    background:#050008;
    padding:.5rem 1rem;
    border-radius:6px;
    border:1px solid var(--brand-bot-40);
    color:#fff;
    transition:filter .2s ease;
  }
  .file-label:hover{filter:brightness(1.1);}
  .file-name{margin-left:.7rem;font-size:.9rem;color:rgba(255,255,255,.7);}
  .select-row{margin:.8rem 0;}

  @keyframes fadeIn{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0);}}
`}</style>

    </div>
  );
};

/* ───────────────── JS-object styles reused ───────────────── */
const styles = {
  input:{
    flex:1,
    height:40,
    padding:'0 8px',
    marginBottom:12,
    border:`1px solid var(--brand-bot-40)`,
    borderRadius:6,
    fontSize:'1rem',
    background:'#050008',
    color:'#fff'
  },
  select:{
    height:40,
    minWidth:160,
    borderRadius:6,
    padding:'0 8px',
    border:`1px solid var(--brand-bot-40)`,
    background:'#050008',
    color:'#fff'
  },
  fileInput:{display:'none'},
  button:{
    padding:'10px 18px',
    background:'var(--brand-grad)',
    color:'#fff', 
    border:'none',
    borderRadius:8,
    fontWeight:700,
    cursor:'pointer',
    boxShadow:'0 0 0 1px var(--brand-bot-40) inset',
    transition:'filter .2s ease'
  },
  tagItem:{
    display:'flex',
    alignItems:'center',
    gap:6,
    background:'#050008',
    border:`1px solid var(--brand-bot-40)`,
    borderRadius:6,
    padding:'4px 8px',
    marginBottom:6,
    fontSize:'.9rem',
    color:'#fff'
  },
  removeBtn:{
    background:'transparent',
    border:'none',
    cursor:'pointer',
    color:'var(--brand-top)',
    fontWeight:700
  }
};


export default Release;
